var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"autohero-searchslider mt-5 mb-5 pt-5 pb-5"},[_c('div',{ref:"autohero",attrs:{"id":"ah-search-slider"}})])}
var staticRenderFns = []

export { render, staticRenderFns }